// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-safety"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M14.498 14.5C16.8935 14.5 19.1026 14.5 21.498 14.5V19.1336C21.498 19.8089 21.1572 20.4387 20.5919 20.808L17.998 22.5024L15.4042 20.808C14.8389 20.4387 14.498 19.8089 14.498 19.1336V14.5Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10.5V7L15 2H4V22H10.5M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M14.498 14.5C16.8935 14.5 19.1026 14.5 21.498 14.5V19.1336C21.498 19.8089 21.1572 20.4387 20.5919 20.808L17.998 22.5024L15.4042 20.808C14.8389 20.4387 14.498 19.8089 14.498 19.1336V14.5Z","strokeWidth":"props.strokeWidth"}}]}]};

const FileSafetyIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-safety',
    ref,
    icon: element,
  },
));

FileSafetyIcon.displayName = 'FileSafetyIcon';

export default FileSafetyIcon;
